import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Typography, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormHelperText, Button, useMediaQuery, Stack, Dialog, DialogTitle, DialogContent, DialogActions, debounce, IconButton } from "@mui/material";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import AddIcon from '@mui/icons-material/Add';
import ComponentHeader from "../commoncomponents/ComponentHeader";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import { useDispatch, useSelector } from "react-redux";
import { addRepairTrackerDetails, assessmentsDetails, clearRepairtracker, updateAssessmentsPartsInitialState, updateAssessmentsPartsRequired, updateOutsourceDetails, updateRepairTrackerDetails, updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import dayjs from "dayjs";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { v4 as uuidv4 } from 'uuid';
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomTimePicker from "../commoncomponents/CustomTimePicker";
import PageLoader from "../commoncomponents/PageLoader";
import { mandatoryFields } from "../../redux/actions/assetActions";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { getAuthToken, getcompanyId } from "../../utility/tokenUtility";
import { addRepairTrackerDetailsRoutineInspection, updateRepairTrackerDetailsRoutineInspection } from "../../redux/actions/routineInspectionActions";
import RoutineInspectionBottomButtons from "./RoutineInspectionBottomButtons";
import riRepository from "../../api/repositories/riRepository";
import { processingPercentageValue, statusList } from "../../utility/message";


const AddRowDialogue = ({ open, onClose, editMode, rows, setRows, vendorName }) => {

  const dispatch = useDispatch();
  
  const initialState = {
    employeename: '',
    flag: {},
    pic: {},
    activity: {},
    startDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    endDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    repairDuration: "0 Mins",
    remarks: "",
    technician: ""

  };

  const [itemData, setItemData] = useState(initialState || {});
  const basicDetails = useSelector((state) => state.routineInspecBasicdetails);
  const setOutsourceDetails = basicDetails?.vendorField;

  const [option, setOption] = useState({
    employeename: [],
    flag: [],
    pic: [],
    activity: [],
  });

  const [error, setError] = useState({
    startDateandTime: false,
    endDateandTime: false,
    employeename: false
  });

  const [errorMessage, setErrorMessage] = useState({
    startDateandTime: "",
    endDateandTime: "",
    employeename: ""
  });

  const handleChangeForRepairTracker = (value, name) => {
    const values = name === "repairDuration" || name === "preparationHours" || name === "verificationHours"
      ? value?.slice(0, 2) + value?.slice(2) : value;

    setItemData((previous) => {
      const updatedData = {
        ...previous,
        [name]: values || ""
      };

      if (name === "employeename") {
        updatedData.employeename = { ...value, label: value?.employeename ? value?.employeename : '' };
      };

      if (name === "startDateandTime" || name === "endDateandTime") {
        const start = new Date(updatedData.startDateandTime);
        const end = new Date(updatedData.endDateandTime);
        if (start && end && end >= start) {
          const durationInMs = end - start;
          const totalMinutes = Math.floor(durationInMs / (1000 * 60)); // Convert duration to total minutes
          updatedData.repairDuration = `${totalMinutes} Mins`;
        } else {
          updatedData.repairDuration = "0 Mins";
        }
      }

      return updatedData;
    });

    setError((prev) => {
      const updatedError = {
        ...prev,
        [name]: false
      };
      return updatedError;
    });

    setErrorMessage((prev) => ({
      ...prev,
      [name]: ''
    }));

    const workOrderDateAndTime = new Date(basicDetails?.workorderDateandTime);
    const selectedDate = new Date(value);
    const currentDate = new Date();
    const endDate = new Date(itemData?.endDateandTime);

    if (name === 'startDateandTime' && value) {

      if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
        setError((prevErrors) => ({
          ...prevErrors,
          startDateandTime: true,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          startDateandTime: "Start date and time should be between Work Order date and current date/time.",
        }));
      } else {
        setError((prevErrors) => ({
          ...prevErrors,
          startDateandTime: false,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          startDateandTime: "",
        }));
      }

      if (endDate && selectedDate) {
        if (selectedDate >= endDate) {
          setError((prevErrors) => ({
            ...prevErrors,
            endDateandTime: true,
          }));
          setErrorMessage((prevErrorMessages) => ({
            ...prevErrorMessages,
            endDateandTime: "End date and time should be greater than the Start date and time.",
          }));
        } else {
          setError((prevErrors) => ({
            ...prevErrors,
            endDateandTime: false,
          }));
          setErrorMessage((prevErrorMessages) => ({
            ...prevErrorMessages,
            endDateandTime: "",
          }));
        }
      };
    };

    if (name === 'endDateandTime' && value) {
      const selectedEndDateTime = new Date(value);
      const startDateTime = new Date(itemData?.startDateandTime);
      if (
        // selectedEndDateTime.toDateString() !== startDateTime.toDateString() || // If the dates are not the same
        selectedEndDateTime < startDateTime 
        // selectedEndDateTime > currentDate
      ) {
        setError((prevErrors) => ({
          ...prevErrors,
          endDateandTime: true,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          endDateandTime: "End date and time should be greater than the Start date and time.",
        }));
      } else {
        setError((prevErrors) => ({
          ...prevErrors,
          endDateandTime: false,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          endDateandTime: "",
        }));
      };
    };
  };

  const fetchOption = async () => {
    const employeeName = await riRepository.fetchEmployeeDetails();
    setOption((previous) => ({
      ...previous,
      employeename: employeeName?.map((item, index) => ({
        key: `option${index}`,
        label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
        employeename: item?.employeename || "",
        employeecode: item?.employeecode || "",
        designation: item?.designation || "",
        empservice: item?.empservice || "",
        id: item?.id || ""
      }))
    }));

    const lovOptions = await riRepository.lovOptions();
    setOption((previous) => ({
      ...previous,
      flag: lovOptions?.femuschworepairflags?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairflag,
        id: item?.id
      }))
    }));

    setOption((previous) => ({
      ...previous,
      pic: lovOptions?.femuschworepairpics?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairpic,
        id: item?.id
      }))
    }));

    setOption((previous) => ({
      ...previous,
      activity: lovOptions?.femuschworepairactivities?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairactivity,
        id: item?.id
      }))
    }));
  };

  useEffect(() => {
    fetchOption();
  }, []);


  const handleCancel = () => {
    setItemData(initialState);
    onClose();
    setErrorMessage({});
    setError({});
  };

  const handleValidationForRequiredFields = () => {
    let isValid = true;

    // Check for required fields
    if (!itemData.startDateandTime) {
      setError((prev) => ({ ...prev, startDateandTime: true }));
      setErrorMessage((prev) => ({ ...prev, startDateandTime: "Start Date and Time is required" }));
      isValid = false;
    }
    if (!itemData.endDateandTime) {
      setError((prev) => ({ ...prev, endDateandTime: true }));
      setErrorMessage((prev) => ({ ...prev, endDateandTime: "End Date and Time is required" }));
      isValid = false;
    }
    if (!itemData.employeename && !setOutsourceDetails) {
      setError((prev) => ({ ...prev, employeename: true }));
      setErrorMessage((prev) => ({ ...prev, employeename: "Employee Name is required" }));
      isValid = false;
    }

    return isValid;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const isValid = handleValidationForRequiredFields();
    if (!isValid) return;

    if (editMode?.dummy_id || editMode?.id) {
      if (editMode?.id) {
        // Update existing row
        const updatedRows = rows.map((row) =>
          row.id === editMode?.id ? itemData : row
        );
        setRows(updatedRows);
      } else if (editMode?.dummy_id) {
        // Update existing row
        const updatedRows = rows.map((row) =>
          row?.dummy_id === editMode?.dummy_id ? itemData : row
        );
        setRows(updatedRows);
      };

      const newUpdatedItem = {
        ...itemData,
        vendorId: vendorName || ""
      };
      dispatch(updateRepairTrackerDetailsRoutineInspection("UPDATE_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION", { ...newUpdatedItem }))
    } else {
      // Add new row
      const newItem = {
        ...itemData,
        dummy_id: uuidv4(),
        vendorId: vendorName || ""
      };

      dispatch(addRepairTrackerDetailsRoutineInspection("ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION", { ...newItem }))
      setItemData(initialState);
    }
    onClose();

  };

  useEffect(() => {
    if (editMode?.dummy_id || editMode?.id) {
      if (editMode?.dummy_id) {
        setItemData({
          dummy_id: editMode?.dummy_id || "",
          activity: {
            key: editMode.activity?.key || "",
            label: `${editMode.activity?.label || ""}` || "",
            id: editMode.activity?.id || "",
          },
          employeename: {
            key: editMode.employeename?.key || "",
            label: `${editMode.employeename?.employeename || ""}`,
            id: editMode.employeename?.id || "",
            designation: editMode.employeename?.designation || "",
            employeename: editMode?.employeename?.employeename || "",
            employeecode: editMode?.employeename?.employeecode || ""
          },
          flag: {
            key: editMode.flag?.key || "",
            label: `${editMode.flag?.label || ""}` || "",
            id: editMode.flag?.id || "",
          },
          pic: {
            key: editMode.pic?.key || "",
            label: `${editMode.pic?.label || ""}` || "",
            id: editMode.pic?.id || "",
          },
          preparationHours: editMode?.preparationHours || "",
          remarks: editMode?.remarks || "",
          repairDuration: editMode?.repairDuration || "",
          startDateandTime: editMode?.startDateandTime || "",
          endDateandTime: editMode?.endDateandTime || "",
          verificationHours: editMode?.verificationHours || "",
          technician: editMode?.technician || "",
          id: editMode?.id || "",
        });
      } else if (editMode?.id) {
        setItemData({
          dummy_id: editMode?.dummy_id || "",
          activity: {
            key: editMode.activity?.key || "",
            label: `${editMode.activity?.label || ""}` || "",
            id: editMode.activity?.id || "",
          },
          employeename: {
            key: editMode.employeename?.key || "",
            label: `${editMode.employeename?.employeename || ""}`,
            id: editMode.employeename?.id || "",
            designation: editMode.employeename?.designation || "",
            employeename: editMode?.employeename?.employeename || "",
            employeecode: editMode?.employeename?.employeecode || ""
          },
          flag: {
            key: editMode.flag?.key || "",
            label: `${editMode.flag?.label || ""}` || "",
            id: editMode.flag?.id || "",
          },
          pic: {
            key: editMode.pic?.key || "",
            label: `${editMode.pic?.label || ""}` || "",
            id: editMode.pic?.id || "",
          },
          preparationHours: editMode?.preparationHours || "",
          remarks: editMode?.remarks || "",
          repairDuration: editMode?.repairDuration || "",
          startDateandTime: editMode?.startDateandTime || "",
          endDateandTime: editMode?.endDateandTime || "",
          verificationHours: editMode?.verificationHours || "",
          technician: editMode?.technician || "",
          id: editMode?.id || "",
          timeStamp: editMode?.timeStamp || "",
        });
      }

    } else {
      setItemData(initialState);
    }
  }, [editMode]);

  const isAddDisabled =
    !(itemData?.employeename?.label || itemData?.technician) ||
    !itemData.startDateandTime ||
    !itemData.endDateandTime ||
    error.startDateandTime ||
    error.endDateandTime ||
    itemData.startDateandTime === "" ||
    itemData.endDateandTime === "";

  return (
    <Dialog
      open={open}
    >
      <DialogTitle>
        <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>{editMode ? "Edit Repair Tracker" : "Add Repair Tracker"}</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {!setOutsourceDetails && <Grid item xs={6} md={6}>
            <CustomTextFieldWithSearch
              autoFocus={true}
              label="Employee Name"
              id="employeename"
              name="employeename"
              value={itemData?.employeename}
              onChange={handleChangeForRepairTracker}
              options={option?.employeename || []}
              error={error?.employeename}
              errorMessage={errorMessage?.employeename || ""}
              isMandatoryField={true}
            />
          </Grid>}
          {setOutsourceDetails &&
            <>
              <Grid item xs={6} md={6}>
                <CustomTextField
                  label={"Vendor"}
                  id={"vendor"}
                  name={"vendor"}
                  value={vendorName || ""}
                  onChange={handleChangeForRepairTracker}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomTextField
                  label={"Vendor Technician"}
                  id={"technician"}
                  name={"technician"}
                  value={itemData?.technician}
                  onChange={handleChangeForRepairTracker}
                  isMandatoryField={true}

                />
              </Grid>
            </>
          }
          <Grid item xs={6} md={6}>
            <CustomSelectInput
              label="Flag"
              id="flag"
              name="flag"
              options={option?.flag || []}
              value={itemData?.flag || ""}
              onChange={handleChangeForRepairTracker}
              modal={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomSelectInput
              label={"Unit"}
              name="pic"
              value={itemData?.pic || ""}
              onChange={handleChangeForRepairTracker}
              options={option?.pic || []}
              modal={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomSelectInput
              label="Activity"
              id="activity"
              name="activity"
              onChange={handleChangeForRepairTracker}
              value={itemData?.activity || ""}
              options={option?.activity || []}
              modal={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomDateTimePicker
              label="Start Date and Time"
              onDateChange={(e) => handleChangeForRepairTracker(e, "startDateandTime")}
              value={itemData?.startDateandTime || ""}
              modal={true}
              disableFutureDate={false}
              error={error?.startDateandTime}
              helperText={errorMessage?.startDateandTime}
              displayDefaultValue={false}
              isMandatoryField={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomDateTimePicker
              label="End Date and Time"
              onDateChange={(e) => handleChangeForRepairTracker(e, "endDateandTime")}
              value={itemData?.endDateandTime || ""}
              shouldValidateFutureTime={true}
              modal={true}
              disableFutureDate={false}
              error={error?.endDateandTime}
              helperText={errorMessage?.endDateandTime}
              displayDefaultValue={false}
              isMandatoryField={true}

            />
          </Grid>
          <Grid item xs={6} md={6}>
            <CustomTextField
              label={"Repair Duration"}
              id={"repairDuration"}
              name={"repairDuration"}
              value={itemData?.repairDuration}
              onChange={handleChangeForRepairTracker}
              disabled
            />
            {/* <CustomTimePicker
              label={"Repair Duration in Hrs"}
              id={"repairDuration"}
              name={"repairDuration"}
              value={itemData?.repairDuration}
              onTimeChange={handleChangeForRepairTracker}
              modal={true}
            /> */}

          </Grid>
          <Grid item xs={6} md={6}>
            <CustomTextField
              label={"Remarks"}
              id={"remarks"}
              name={"remarks"}
              value={itemData?.remarks}
              onChange={handleChangeForRepairTracker}
              maxlength={255}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSave} disabled={isAddDisabled}>
          {editMode ? "UPDATE" : "ADD"}
        </Button>
        <Button variant="outlined" onClick={handleCancel}>
          CANCEL
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const RoutineInspectionAssessments = ({ setPage, page, buttonAttributes }) => {

  //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
  const findHeaderContent = buttonAttributes.find(
    (item) => item.currentPageName === page
  );

  function AddRowButton({ onClick }) {
    return (
      <Box sx={{ mt: 2 }}>
        <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={onClick}>
          Add Row
        </Button>
      </Box>
    );
  };
  const location = useLocation();
  const viewmode = location.state?.viewmode;
  const status = useSelector((state) => state?.workOrderStatus?.status);
  const assessmentsMandatoryFields = useSelector((state) => state?.routineInspecMandatoryFields?.assessmentsMandatoryFields);  
  const assetCategoryType = useSelector((state) => state?.serviceType);
  const basicDetails = useSelector((state) => state?.routineInspecBasicdetails);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const token = getAuthToken("id_token");
  const companyId = getcompanyId('companyId');

  const dispatch = useDispatch();
  const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
  const assessments = basicDetails?.assessments || {};
  const setOutsourceDetails = basicDetails?.vendorField;
  const categoryType = assetCategoryType?.category;
  const setScheduledField = categoryType === "Scheduled" ? true : false;
  const repairTrackerRows = basicDetails?.assessments?.repairTracker || [];

  const [outSourceDialog, setOutSourceDialog] = useState(false);
  const [gridAPI, setGridApi] = useState({});
  const [assessmentsdata, setAssessmentsData] = useState(assessments || {});
  const [rows, setRows] = useState(repairTrackerRows || []);
  const[deleteRows,setDeleteRows] = useState([]);
  const [empFieldDisable, setEmpFieldDisabled] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorDialogMssg, setErrorDialogMssg] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOnchange, setIsOnchange] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    respondedBy: "",
    taskCode: "",
    repairType: "",
    repairTrackerRows: "",
    vendor:""
  });
  const [error, setError] = useState({
    respondedBy: false,
    taskCode: false,
    repairType: false,
    repairTrackerRows: false,
    vendor:false
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [option, setOption] = useState({
    respondedBy: [],
    taskCode: [],
    vendor: []
  });
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scheduled, setScheduled] = useState(setScheduledField);
  const [pageName, setPageName] = useState("Part Replacement");

  const statusMapping = {
      "Open": 1,
      "Scheduled":2,
      "In Progress": 3,
      "Completed": 4,
      "Closed": 5,
      "Cancelled": 6,
      "Verified":8,
      "Not Done and Closed":7,
      "Completed-Outsource":9,
  };

  // Map the current status to the corresponding number
  const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value
  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    };
    const formattedDate = format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss'); // Format the date as 'dd/MM/yyyy HH:mm:ss'
    return formattedDate;
  };

  const columns_Field = [
    ...(setOutsourceDetails || !!(assessmentsdata?.repairType === "Outsource")
      ? [
        { field: 'vendor', headerName: 'Vendor', flex: 1,valueGetter: (params) => params?.data ? assessmentsdata?.vendor?.label || "" : ""},
        { field: 'technician', headerName: 'Vendor Technician', flex: 1 },
      ]
      : [
        {
          field: 'employeeName',
          headerName: 'Employee Name',
          flex: 1,
          minWidth: isSmallScreen ? 150 : 200,
          valueGetter: (params) => params?.data?.employeename ? params?.data.employeename?.employeename : '',
        }
      ]
    ),
    {
      field: 'flag',
      headerName: 'Flag',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => params?.data?.flag ? params?.data.flag?.label : '',
    },
    {
      field: 'pic',
      headerName: 'Unit',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => params?.data?.pic ? params?.data.pic?.label : '',
    },
    {
      field: 'activity',
      headerName: 'Activity',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => params?.data?.activity ? params?.data.activity?.label : '',
    },
    {
      field: 'startDateandTime',
      headerName: 'Start Date/Time ',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => formatDate(params?.data?.startDateandTime),
    },
    {
      field: 'endDateandTime',
      headerName: 'End Date/Time ',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => formatDate(params?.data?.endDateandTime),
    },
    {
      field: 'repairDuration',
      headerName: 'Repair Duration',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
    }
  ];

  useEffect(() => {
    setRows(repairTrackerRows || [])
    if (repairTrackerRows?.length > 0) {
      setError((prev) => ({
        ...prev,
        repairTrackerRows: false,
      }));

      setErrorMessage((prev) => ({
        ...prev,
        repairTrackerRows: ""
      }))
    }

  }, [repairTrackerRows])
  // }, [repairTrackerRows])

  const getStepper = useSelector((state) => state?.checkParts);
  const withPartsRequired = getStepper;
  const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

  const handleOnchange = async (value, name) => {
    setAssessmentsData((previous) => {
      const updatedData = {
        ...previous,
        [name]: value,
      };

      if (name === "respondedBy") {
        if (value?.id) {
          updatedData.respondedBy = { ...value, label: value?.employeename };
          updatedData.designation = value?.designation;
        } else {
          updatedData.respondedBy = "";
          updatedData.designation = "";
        }
      };

      if (name === "taskCode") {
        if (value?.id) {
          updatedData.taskCode = { ...value, label: value?.taskCode }
          updatedData.taskDescription = value?.taskDesc;
        } else {
          updatedData.taskCode = "";
          updatedData.taskDescription = "";
        }
      };

      if (name === "partsRequired") {
        if (value?.label === 'No') {
          dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
          // setPageName("Completion Info");
        } else {
          dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
          // setPageName("Part Replacement");
        }
      };

      if (name === 'repairType') {
        dispatch(updateOutsourceDetails("SET_VENDORFIELD_ROUTINE_INSPECTION", value === 'Outsource' ? true : false));
        if (value === 'Outsource') {
          updatedData.vendor = { id: "", label: "" };
          // updatedData.respondedBy = { id: "", label: "" };
          // updatedData.designation = "";

          // Dispatch action to clear repair tracker
          dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []));
          setAssessmentsData((previousValue) => ({
            ...previousValue,
            vendor:""
          }));

          setError((prev)=>({
            ...prev,
            repairTrackerRows:false
          }));
  
          setErrorMessage((prev)=>({
            ...prev,
            repairTrackerRows:""
          }))

        } else {
          // Dispatch action to clear repair tracker
          dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []));
          
          setAssessmentsData((previousValue) => ({
            ...previousValue,
            vendor: ""
          }));

          setError((prev)=>({
            ...prev,
            repairTrackerRows:false
          }));
  
          setErrorMessage((prev)=>({
            ...prev,
            repairTrackerRows:""
          }))
        }
      };

      if (name === "vendor") {
        setAssessmentsData((previousValue) => {
          const currentVendor = previousValue.vendor?.id || ""; // Get the current vendor ID
          const newVendor = value?.id || ""; // Get the new vendor ID
      
          // Check if the vendor has changed
          if (currentVendor !== newVendor && !isOnchange) {
            // if (!newVendor) {
              // If the new vendor is empty (vendor is removed), set rows in deletedRows state
              setDeleteRows(rows || []);
            // } else {
            //   // If a new vendor is added, set the previous rows in the deletedRows state
            //   setDeleteRows((prevDeletedRows) => [...prevDeletedRows, ...(rows || [])]);
            // }
            // Dispatch action to clear repair tracker
            dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []));
      
            return {
              ...previousValue,
              vendor: value || { id: "", label: "" }, // Update the vendor field
            };
          } else {
            return previousValue; // Return unchanged state if the vendor hasn't changed
          }
        });
      }

      return updatedData;
    });

    const workOrderDateAndTime = basicDetails?.workorderDateandTime;
    if (name === 'respondedStartDateandTime' && value && workOrderDateAndTime) {
      const workOrderDate = new Date(workOrderDateAndTime);
      const selectedDate = new Date(value);
      const endDate = new Date(assessmentsdata?.respondedEndDateandTime);

      if (selectedDate < workOrderDate) {
        setError((prev) => ({
          ...prev,
          respondedStartDateandTime: true
        }));

        setErrorMessage((prev) => ({
          ...prev,
          respondedStartDateandTime: "Responded Start date and time should be greater than the work order date and time."
        }));
        return;
      } else {
        setError((prev) => ({
          ...prev,
          respondedStartDateandTime: false
        }));
        setErrorMessage((prev) => ({
          ...prev,
          respondedStartDateandTime: ""
        }));

      }

      // Check if the end date is before the start date
      if (endDate && selectedDate > endDate) {
        setError(prevErrors => ({
          ...prevErrors,
          respondedEndDateandTime: true,
        }));
        setErrorMessage(prevErrorMessages => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "Responded End date and time should be greater than the Responded Start date and time.",
        }));
      } else if (error.respondedEndDateandTime) {
        setError(prevErrors => ({
          ...prevErrors,
          respondedEndDateandTime: false,
        }));
        setErrorMessage(prevErrorMessages => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "",
        }));
      };
    };

    if (name === 'respondedEndDateandTime' && value) {
      const respondStartdateandTime = new Date(assessmentsdata?.respondedStartDateandTime);
      const selectedDate = new Date(value);
      if (selectedDate < respondStartdateandTime) {
        setError({
          ...error,
          respondedEndDateandTime: true,
        });
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "Responded End date and time should be greater than the Response Start date and time.",
        }));
        return;
      } else {
        setError((prevErrors) => ({
          ...prevErrors,
          respondedEndDateandTime: false,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "",
        }));
      };
    };

    setError((prev) => {
      const updatedError = {
        ...prev,
        [name]: false
      };
      return updatedError;
    });

    setErrorMessage((prev) => ({
      ...prev,
      [name]: ''
    }));
  };

  const handleRepairTypeChange = (event) => {
    handleOnchange(event.target.value, "repairType");
  };

  const memoizedDetails = useMemo(() => ({
    respondedBy: assessmentsdata?.respondedBy || "",
    taskCode: assessmentsdata?.taskCode || '',
    repairType: assessmentsdata?.repairType || '',
    vendor:assessmentsdata?.vendor || ""
  }), [
    assessmentsdata?.respondedBy,
    assessmentsdata?.taskCode,
    assessmentsdata?.repairType,
    assessmentsdata?.vendor
  ]);

  //function to check the mandatory field are filled or not(responsible for green ticks on left side)
  const checkMandatoryValueFilled = useCallback(debounce((
    respondedBy,
    taskCode,
    repairType,
    vendor
  ) => {
    const updateStatus = (type, value, name, isVisible, errorState) => ({
      type,
      valueFilled: !errorState && !!value,
      name,
      isVisible
    });
    const updateRespondedBy = updateStatus("Assignee", respondedBy, 'respondedBy', !(scheduled && setOutsourceDetails), error.respondedBy);
    const updateTaskCode = updateStatus("Task Code", taskCode, 'taskCode', true, error.taskCode);
    const updaterepairType = updateStatus("Repair Type", repairType, 'repairType', true, error.repairType);
    const updateVendor = updateStatus("Vendor", vendor, 'vendor', setOutsourceDetails, error.vendor);

    let arrayAfterUpdating = [
      updateTaskCode,
      updaterepairType,
    ];

    if(!(scheduled && setOutsourceDetails)){
      arrayAfterUpdating.push(updateRespondedBy)
    };

    if(setOutsourceDetails){
      arrayAfterUpdating?.push(updateVendor)
    };


    if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
      dispatch({ type: "UPDATE_ROUTINE_INSPECTION_ASSESMENTS_MANDATORY_FIELDS", payload: arrayAfterUpdating })
    }
  }), [dispatch, error,setOutsourceDetails]);

  useEffect(() => {
    const {
      respondedBy,
      taskCode,
      repairType,
      vendor
    } = memoizedDetails;
    checkMandatoryValueFilled(
      respondedBy?.id,
      taskCode?.id,
      repairType,
      vendor?.id
    );
  }, [
    memoizedDetails,
    checkMandatoryValueFilled
  ]);


  const handleValidationForRequiredFields = () => {
    let isValid = true;

    // Check if any error state is true
    if (Object.values(error).some((value) => value === true)) {
      isValid = false;
    }

    assessmentsMandatoryFields.map((item) => {
      if (item.valueFilled === false && !error[item.name]) {
        if (error[item.name]) {
          isValid = false;
        } else {
          setError((prev) => ({
            ...prev,
            [item.name]: true,
          }));
          setErrorMessage((prev) => ({
            ...prev,
            [item.name]: `${item.type} is required `,
          }));
        }

        isValid = false;
      }
    });

    if (repairTrackerRows <= 0 && (!(assessmentsdata?.repairType === "Outsource"))) {
      // if (repairTrackerRows <= 0) {
    // if (repairTrackerRows <= 0 && (!!(assessmentsdata?.repairType === "Outsource") || !setOutsourceDetails)) {
      setError((prev) => ({
        ...prev,
        repairTrackerRows: true,
      }));
      setErrorMessage((prev) => ({
        ...prev,
        repairTrackerRows: "Please add at least one repair tracker row",
      }));
      isValid = false;
    }
    return isValid;
  };

  const getEmpNameForAutoAssign = async () => {
    const employeeResponse = await riRepository.fetchEmployeeDetails();

    const mapEmployeeIdToName = (id) => {
      const employee = employeeResponse?.find(emp => emp?.id === id);
      // const employee = employeeResponse?.find(emp => emp?.userid === id);
      return employee ? employee?.employeename : '';
    };

    const mapEmployeeIdToDesignation = (id) => {
      const employee = employeeResponse?.find(emp => emp?.id === id);
      // const employee = employeeResponse?.find(emp => emp?.userid === id);
      return employee ? employee?.designation : '';
    };

    const mapEmployeeIdToCode = (id) => {
      const employee = employeeResponse?.find(emp => emp?.id === id);
      return employee ? employee?.employeecode : '';
    };

    try {
      const employeeName = await riRepository.autoAssignedEmp(serviceType, basicDetails?.id);
      if (employeeName?.id) {
        setAssessmentsData((prev) => ({
          ...prev,
          respondedBy: { id: employeeName?.respondedbyid, label: mapEmployeeIdToName(employeeName?.respondedbyid), employeecode: mapEmployeeIdToCode(employeeName?.respondedbyid) },
          designation: mapEmployeeIdToDesignation(employeeName?.respondedbyid),
          respondedStartDateandTime: employeeName?.respondedstartdate
        }));
        setEmpFieldDisabled(true);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    // if (basicDetails?.editmode === false) {
    //   setAssessmentsData((previousValue) => {
    //     return {
    //       ...previousValue,
    //       vendor: ''
    //     }
    //   });
    // } else {
      setAssessmentsData((previousValue) => {
        return {
          ...previousValue,
          vendor: assessments?.vendor || ''

        }
      });
    // }

    setScheduled(setScheduledField);

  }, [basicDetails?.editmode, empFieldDisable])

  const fetchOptions = async () => {
    const respondedBy = await riRepository.fetchEmployeeDetails();
    setOption((previous) => ({
      ...previous,
      respondedBy: respondedBy?.map((item, index) => ({
        key: `option${index}`,
        label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
        employeename: item?.employeename || "",
        employeecode: item?.employeecode || "",
        designation: item?.designation || "",
        empservice: item?.empservice || "",
        id: item?.id
      }))
    }));



    if (!scheduled) {
      let workGroupId = basicDetails?.workGroupId || basicDetails?.assetNo?.workGroupId || basicDetails?.referenceWorkRequestNo?.workGroupId || "";

      const taskCode = await riRepository.fetchTaskCode(serviceType, workGroupId);
      setOption((previous) => ({
        ...previous,
        taskCode: taskCode?.map((item, index) => ({
          key: `option${index}`,
          label: `${item?.taskcode || ""} - ${item?.taskdesc || ""}` || "",
          taskCode: item?.taskcode || "",
          taskDesc: item?.taskdesc || "",
          serviceName: item?.service || "",
          wgCode: item?.wgcode || "",
          wgDesc: item?.wgdesc || "",
          wgId: item?.wgId || "",
          id: item?.id || "",

        }))
      }));
    };


    const vendorOptions = await riRepository.fetchVendorDetails();
    setOption((previous) => ({
      ...previous,
      vendor: vendorOptions?.map((details, index) => ({
        key: `option${index}`,
        label: details?.vendorname || "",
        vendorName: details?.vendorname || "",
        vendorcode: details?.vendorcode || "",
        vendoremail: details?.vendoremail || "",
        serviceCode: details?.servicecode || "",
        id: details?.id
      }))
    }))
  };

  const handleOutsourceSubmit = () => {
    setOutSourceDialog(false);
  };

  const handleDelete = (row) => {
    setDeleteDialog(true);
    setDeleteId(row)
  };

  const handleCloseCancelDialog = () => {
    setDeleteDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await riRepository.deleteRepairTracker(serviceType,deleteId?.id);

      let updatedRows = [];

      if (deleteId?.id) {
        updatedRows = rows?.filter((row) => row?.id !== deleteId?.id);
        setRows(updatedRows);
        dispatch({ type: 'DELETE_REPAIR_TRACKER_ROUTINE_INSPECTION', payload: { id: deleteId?.id } });
        setDeleteDialog(false);
      } else if (deleteId?.dummy_id) {
        updatedRows = rows?.filter((row) => row?.dummy_id !== deleteId?.dummy_id);
        setRows(updatedRows);
        dispatch({ type: 'DELETE_REPAIR_TRACKER_ROUTINE_INSPECTION', payload: { dummy_id: deleteId?.dummy_id } });
        setDeleteDialog(false);
      };

    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    const isValid = handleValidationForRequiredFields();

    if (!viewmode && mappedStatus !== 6 && isValid) {

      const employeeName = await riRepository.fetchEmployeeDetails();
      const lovOptions = await riRepository.lovOptions();
      const mapEmpCode = (id) => {
        const empCode = employeeName?.find(empc => empc.id === id);
        return empCode ? empCode.employeecode : '';
      };

      const mapEmpName = (id) => {
        const empCode = employeeName?.find(empN => empN.id === id);
        return empCode ? empCode.employeename : '';
      };

      const mapFlagDesc = (id) => {
        const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
        return flagDesc ? flagDesc?.repairflag : '';
      };

      const mapPicDesc = (id) => {
        const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
        return picDesc ? picDesc?.repairpic : '';
      };

      const mapActivityDesc = (id) => {
        const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
        return activityDesc ? activityDesc?.repairactivity : '';
      };

      const API_Payload = {
        respondedbyid: assessmentsdata?.respondedBy?.id || "",
        respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
        respondfinding: assessmentsdata?.respondedFinding || "",
        ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
        isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
        vendorid: assessmentsdata?.vendor?.id || "",
        Respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
        [`${serviceType}routineinspectionheaderId`]: basicDetails?.id || "",
        [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
        [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
        isrespond:basicDetails?.isresponse === "Yes" ? 1 : "",
        id: assessments?.id || "",
      };

      if (basicDetails?.assessments?.id) {

        const assesmentsId = basicDetails?.assessments?.id || "";

        const updateRepairDetailsPayload = rows?.map((row) => ({
          employeeid: row?.employeename?.id || "",
          repairstartdate: row?.startDateandTime || "",
          repairenddate: row?.endDateandTime || "",
          repairduration: row?.repairDuration || "",
          preparationhours: row?.preparationHours || "",
          verificationhours: row?.verificationHours || "",
          remarks: row?.remarks || "",
          Vendortechnician: row?.technician || "",
          [`${serviceType}routineinspectionheaderId`]: basicDetails?.id || "",
          [`${serviceType}routineinspectassesmentheaderId`]: assesmentsId|| "",
          [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
          [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
          [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
          id: row?.id || "",
          timestamp: row?.timeStamp || ""
        }));

        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []));
        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                riRepository.deleteRepairTracker(
                  serviceType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }
        const updateAssessmentDetailsResponse = await riRepository.updateAssessmentsDetails(serviceType, API_Payload, categoryType,);
        if (updateRepairDetailsPayload?.length > 0) {
          const saveRepairTracker = await riRepository.updateRepairTracker(serviceType, updateRepairDetailsPayload, categoryType, assesmentsId);
          saveRepairTracker?.forEach((row) => {
            const transformedObject = {
              employeename: {
                employeeCode: mapEmpCode(row?.employeeid || ""),
                employeename: mapEmpName(row?.employeeid || ""),
                id: row?.employeeid || "",
              },
              flag: {
                id: row?.[`${serviceType}uschworepairflagId`] || "",
                label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
              },
              pic: {
                id: row?.[`${serviceType}uschworepairpicId`] || "",
                label: mapPicDesc(row?.[`${serviceType}uschworepairflagId`] || "")
              },
              activity: {
                id: row?.[`${serviceType}uschworepairactivityId`] || "",
                label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
              },
              technician:row?.vendortechnician || "",
              startDateandTime: row?.repairstartdate || "",
              endDateandTime: row?.repairenddate || "",
              repairDuration: row?.repairduration || "",
              preparationHours: row?.preparationhours || "",
              verificationHours: row?.verificationhours || "",
              remarks: row?.remarks || "",
              id: row?.id || "",
              timeStamp: row?.timestamp || ""
            };
            dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION", transformedObject));
          });
        };
        if (updateAssessmentDetailsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS_ROUTINE_INSPECTION", { ...assessmentsdata, id: updateAssessmentDetailsResponse?.id || "", timeStamp: updateAssessmentDetailsResponse?.timestamp || "" }));
          // setPage(pageName);
          setPage("Attachments")
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        } else if (updateAssessmentDetailsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }
      }

      else {
        const createAssessmentsResponse = await riRepository.addAssessmentsDetails(serviceType, API_Payload, categoryType);
        const repairDetailsPayload = rows?.map((row) => ({
          employeeid: row?.employeename?.id || "",
          repairstartdate: row?.startDateandTime || "",
          repairenddate: row?.endDateandTime || "",
          repairduration: row?.repairDuration || "",
          preparationhours: row?.preparationHours || "",
          verificationhours: row?.verificationHours || "",
          remarks: row?.remarks || "",
          Vendortechnician: row?.technician || "",
          [`${serviceType}routineinspectionheaderId`]: basicDetails?.id || "",
          [`${serviceType}routineinspectassesmentheaderId`]: createAssessmentsResponse?.id || "",
          [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
          [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
          [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
          id: row?.id || "",
          timestamp: row?.timeStamp || ""
        }));

        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []))
        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                riRepository.deleteRepairTracker(
                  serviceType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }

        const saveRepairTracker = await riRepository.addRepairTracker(serviceType, repairDetailsPayload, categoryType);

        saveRepairTracker?.forEach((row) => {
          const transformedObject = {
            employeename: {
              employeeCode: mapEmpCode(row?.employeeid || ""),
              employeename: mapEmpName(row?.employeeid || ""),
              id: row?.employeeid || "",
            },
            flag: {
              id: row?.[`${serviceType}uschworepairflagId`] || "",
              label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
            },
            pic: {
              id: row?.[`${serviceType}uschworepairpicId`] || "",
              label: mapPicDesc(row?.[`${serviceType}uschworepairflagId`] || "")
            },
            activity: {
              id: row?.[`${serviceType}uschworepairactivityId`] || "",
              label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
            },
            technician:row?.vendortechnician || "",
            startDateandTime: row?.repairstartdate || "",
            endDateandTime: row?.repairenddate || "",
            repairDuration: row?.repairduration || "",
            preparationHours: row?.preparationhours || "",
            verificationHours: row?.verificationhours || "",
            remarks: row?.remarks || "",
            id: row?.id || "",
            timeStamp: row?.timestamp || ""
          };
          dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION", transformedObject));
        });
        if (createAssessmentsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS_ROUTINE_INSPECTION", { ...assessmentsdata, id: createAssessmentsResponse?.id || "", timeStamp: createAssessmentsResponse?.timestamp || "" }));
          dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status:  (assessmentsdata?.repairType === "Inhouse" || assessments?.repairType === "Inhouse") ? statusList?.inProgress?.label : statusList?.inProgressOutsource?.label, percentage: processingPercentageValue?.assessmentTab }));
          setPage("Attachments")
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        } else if (createAssessmentsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }
      };

    }
    else if (isValid && (mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 8)) {
      // setPage(pageName);
      setPage("Attachments")
      dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    } else if (viewmode == true || mappedStatus === 6) {
      // setPage(pageName);
      setPage("Attachments")
      dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    }
    setLoading(false);

  };


  const handledialogforOutSource = async () => {
    setLoading(true);
    const isValid = handleValidationForRequiredFields();
    if (isValid) {


      const employeeName = await riRepository.fetchEmployeeDetails();
      const lovOptions = await riRepository.lovOptions();
      const mapEmpCode = (id) => {
        const empCode = employeeName?.find(empc => empc.id === id);
        return empCode ? empCode.employeecode : '';
      };

      const mapEmpName = (id) => {
        const empCode = employeeName?.find(empN => empN.id === id);
        return empCode ? empCode.employeename : '';
      };

      const mapFlagDesc = (id) => {
        const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
        return flagDesc ? flagDesc?.repairflag : '';
      };

      const mapPicDesc = (id) => {
        const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
        return picDesc ? picDesc?.repairpic : '';
      };

      const mapActivityDesc = (id) => {
        const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
        return activityDesc ? activityDesc?.repairactivity : '';
      };

      const API_Payload = {
        respondedbyid: assessmentsdata?.respondedBy?.id || "",
        respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
        respondfinding: assessmentsdata?.respondedFinding || "",
        ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
        isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
        vendorid: assessmentsdata?.vendor?.id || "",
        Respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
        [`${serviceType}routineinspectionheaderId`]: basicDetails?.id || "",
        [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
        [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
        isrespond:basicDetails?.isresponse === "Yes" ? 1 : "",
        id: assessments?.id || "",
      };

      if (basicDetails?.assessments?.id) {

        const assesmentsId = basicDetails?.assessments?.id || "";

        const updateRepairDetailsPayload = rows?.map((row) => ({
          employeeid: row?.employeename?.id || "",
          repairstartdate: row?.startDateandTime || "",
          repairenddate: row?.endDateandTime || "",
          repairduration: row?.repairDuration || "",
          preparationhours: row?.preparationHours || "",
          verificationhours: row?.verificationHours || "",
          Vendortechnician: row?.technician || "",
          remarks: row?.remarks || "",
          [`${serviceType}routineinspectionheaderId`]: basicDetails?.id || "",
          [`${serviceType}routineinspectassesmentheaderId`]: assesmentsId || "",
          [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
          [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
          [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
          id: row?.id || "",
          timestamp: row?.timeStamp || ""
        }));

        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []));

        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                riRepository.deleteRepairTracker(
                  serviceType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }

        const updateAssessmentDetailsResponse = await riRepository.updateAssessmentsDetails(serviceType, API_Payload, categoryType);

        if (updateRepairDetailsPayload?.length > 0) {
          const saveRepairTracker = await riRepository.updateRepairTracker(serviceType, updateRepairDetailsPayload, categoryType, assesmentsId);
          saveRepairTracker?.forEach((row) => {
            const transformedObject = {
              employeename: {
                employeeCode: mapEmpCode(row?.employeeid || ""),
                employeename: mapEmpName(row?.employeeid || ""),
                id: row?.employeeid || "",
              },
              flag: {
                id: row?.[`${serviceType}uschworepairflagId`] || "",
                label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
              },
              pic: {
                id: row?.[`${serviceType}uschworepairpicId`] || "",
                label: mapPicDesc(row?.[`${serviceType}uschworepairflagId`] || "")
              },
              activity: {
                id: row?.[`${serviceType}uschworepairactivityId`] || "",
                label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
              },
              technician:row?.vendortechnician || "",
              startDateandTime: row?.repairstartdate || "",
              endDateandTime: row?.repairenddate || "",
              repairDuration: row?.repairduration || "",
              preparationHours: row?.preparationhours || "",
              verificationHours: row?.verificationhours || "",
              remarks: row?.remarks || "",
              id: row?.id || "",
              timeStamp: row?.timestamp || ""
            };
            dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION", transformedObject));
          });
        }

        const service = assetCategoryType?.assetType === "fem" ? "FEMS" : "BEMS";
        const graphUrl = `${window.location.hostname}:${window.location.port}`;
        const emailPayload = {
          vendorId: assessmentsdata?.vendor?.id || "",
          workorderId: basicDetails?.id || "",
          applicationSecurityKey: "ENC45TY-09",
          url: graphUrl,
          serviceId: "",
          service: service,
          token: token,
          category: categoryType,
          statusId: mappedStatus || 3,
          Workordertype:scheduled ? basicDetails?.type?.label : "",
          companyId:companyId || "",
          vendorName:assessmentsdata?.vendor?.label || ""
        };
        await riRepository.sendVendorEmail(serviceType, emailPayload);

        if (updateAssessmentDetailsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS_ROUTINE_INSPECTION", { ...assessmentsdata, id: updateAssessmentDetailsResponse?.id || "", timeStamp: updateAssessmentDetailsResponse?.timestamp || "" }));
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        } else if (updateAssessmentDetailsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }
      }

      else {
        

        const createAssessmentsResponse = await riRepository.addAssessmentsDetails(serviceType, API_Payload, categoryType);

        const repairDetailsPayload = rows?.map((row) => ({
          employeeid: row?.employeename?.id || "",
          repairstartdate: row?.startDateandTime || "",
          repairenddate: row?.endDateandTime || "",
          repairduration: row?.repairDuration || "",
          preparationhours: row?.preparationHours || "",
          verificationhours: row?.verificationHours || "",
          remarks: row?.remarks || "",
          Vendortechnician: row?.technician || "",
          [`${serviceType}routineinspectionheaderId`]: basicDetails?.id || "",
          [`${serviceType}routineinspectassesmentheaderId`]: createAssessmentsResponse?.id || "",
          [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
          [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
          [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
          id: row?.id || "",
          timestamp: row?.timeStamp || ""
        }));

        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION", []))

        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                riRepository.deleteRepairTracker(
                  serviceType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }

        const saveRepairTracker = await riRepository.addRepairTracker(serviceType, repairDetailsPayload, categoryType);
        const rtLength = saveRepairTracker?.length;
        const getRepairTrackerId = saveRepairTracker?.[rtLength - 1];

        saveRepairTracker?.forEach((row) => {
          const transformedObject = {
            employeename: {
              employeeCode: mapEmpCode(row?.employeeid || ""),
              employeename: mapEmpName(row?.employeeid || ""),
              id: row?.employeeid || "",
            },
            flag: {
              id: row?.[`${serviceType}uschworepairflagId`] || "",
              label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
            },
            pic: {
              id: row?.[`${serviceType}uschworepairpicId`] || "",
              label: mapPicDesc(row?.[`${serviceType}uschworepairflagId`] || "")
            },
            activity: {
              id: row?.[`${serviceType}uschworepairactivityId`] || "",
              label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
            },
            technician:row?.vendortechnician || "",
            startDateandTime: row?.repairstartdate || "",
            endDateandTime: row?.repairenddate || "",
            repairDuration: row?.repairduration || "",
            preparationHours: row?.preparationhours || "",
            verificationHours: row?.verificationhours || "",
            remarks: row?.remarks || "",
            id: row?.id || "",
            timeStamp: row?.timestamp || ""
          };
          dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION", transformedObject));
        });
        const service = assetCategoryType?.assetType === "fem" ? "FEMS" : "BEMS";
        const graphUrl = `${window.location.hostname}:${window.location.port}`;
        const emailPayload = {
          vendorId: assessmentsdata?.vendor?.id || "",
          workorderId: basicDetails?.id || "",
          applicationSecurityKey: "ENC45TY-09",
          url: graphUrl,
          serviceId: "",
          service: service,
          token: token,
          category: categoryType,
          statusId: mappedStatus || 3,
          Workordertype:scheduled ? basicDetails?.type?.label : "",
          companyId:companyId || "",
          vendorName:assessmentsdata?.vendor?.label || ""
        };
        await riRepository.sendVendorEmail(serviceType, emailPayload);

        if (createAssessmentsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS_ROUTINE_INSPECTION", { ...assessmentsdata, id: createAssessmentsResponse?.id || "", repairtrackerId: getRepairTrackerId?.id || "", timeStamp: createAssessmentsResponse?.timestamp || "" }));
          dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.inProgressOutsource?.label, percentage: processingPercentageValue?.assessmentTab }))
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED")); // Access the checked state of the switch using event.target.checked and set false switch action  
        } else if (createAssessmentsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }

      };

    }
    setLoading(false);
    if (isValid) {
      setOutSourceDialog(true);
    }

  };
  const getAutoAssign = async()=>{
        setLoading(true);
        await  getEmpNameForAutoAssign();
  }
    

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchOptions();

      // if (assessments?.partsRequired?.id === 1) {
      //   setPageName("Part Replacement");
      // } else if (assessments?.partsRequired?.id === 2) {
      //   setPageName("Completion Info");
      // } else {
      //   setPageName("Part Replacement");
      // }
    };
    fetchData();
    setLoading(false);

    if (assessments?.id) {
      return;
    } else {

 

      setAssessmentsData((prev) => ({
        ...prev,
        respondedStartDateandTime: empFieldDisable ? prev?.respondedStartDateandTime : dayjs().format("YYYY-MM-DDTHH:mm:ss"),
        respondedEndDateandTime: prev?.respondedEndDateandTime || "",
      }));

    //  getAutoAssign();
      setLoading(false);    
    }

  }, []);


  const handleConfirm = () => {
    handleCloseDialog();
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditData(null);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setDialogOpen(true);
  };

  const handleCloseErrRequestDialog = () => {
    setErrorDialog(false);
    setErrorDialogMssg("");
  };

  const handleConfirmErrRequestDialog = (e) => {
    e.preventDefault();
    setErrorDialog(false);
    setErrorDialogMssg("")
  };


  // const handleOpenModal = () => setIsModalOpen(true);
  // const handleCloseModal = () => setIsModalOpen(false);

  // const handleTaskCodeClick = (rowData) => {
  //   setAssessmentsData((prev) => ({
  //     ...prev,
  //     taskCode: { ...rowData, label: rowData?.taskCode ? rowData?.taskCode : '' },
  //     taskDescription: rowData?.taskDesc || ""
  //   }));

  //   setError((prev) => ({
  //     ...prev,
  //     taskCode: false

  //   }));

  //   setErrorMessage((prev) => ({
  //     ...prev,
  //     taskCode: ''
  //   }));

  //   // Close the modal after asset selection
  //   handleCloseModal();
  // };

  // const columns = [
  //   {
  //     headerName: 'Task Code',
  //     field: 'taskCode',
  //     width: 150,
  //     cellRenderer: (params) => (
  //       <a
  //         href="#"
  //         onClick={(e) => {
  //           e.preventDefault();
  //           handleTaskCodeClick(params.data);
  //         }}
  //         style={{
  //           color: 'blue',
  //           textDecoration: 'underline',
  //           cursor: 'pointer',
  //         }}
  //       >
  //         {params.value}
  //       </a>
  //     ),
  //   },
  //   { headerName: 'Task Description', field: 'taskDesc', width: 200 },
  //   { headerName: 'Service', field: 'serviceName', width: 100 },
  //   { headerName: 'Work Group Code', field: 'wgCode', width: 150 },
  //   { headerName: 'Work Group Description', field: 'wgDesc', width: 150 }

  // ];

  const shouldEnableDeleteAndEdit = !viewmode && mappedStatus !== 6;
  // const shouldEnableDeleteAndEdit = !viewmode && mappedStatus !== 4 && mappedStatus !== 5 && mappedStatus !== 6 || mappedStatus !== 8;


  return (
    <>
      <PageLoader open={loading} />
      <ComponentHeader
        mainHeader={findHeaderContent?.mainHeader}
        subHeader={findHeaderContent?.subHeader}
        secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
        requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
      />
      <Box >
        <form style={{ position: "relative" }} onSubmit={handleSubmit} noValidate>
          <Stack direction={'row'} alignItems={'center'} gap={1.5}>
            <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.workOrderNo || ""}</Typography>
          </Stack>
          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Grid container spacing={2}>
              {/* { (!setOutsourceDetails || !(assessmentsdata?.repairType === "Outsource")) && ( */}
                <>
                  <Grid item xs={12} md={4} sm={6}>
                  <CustomTextFieldWithSearch
                     label={"Assignee"}
                     id="respondedDetails"
                     name="respondedBy"
                     onChange={handleOnchange}
                     options={option?.respondedBy || []}
                     error={error?.respondedBy}
                     errorMessage={errorMessage?.respondedBy || ""}
                     value={assessmentsdata?.respondedBy || ""}
                     disabled={viewmode || mappedStatus === 6}
                     // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || assessments?.id || empFieldDisable}
                     autoFocus
                     isMandatoryField={!(scheduled && setOutsourceDetails) ? true : false}
                  />
                  </Grid>
                  <Grid item xs={12} md={4} sm={6}>
                    <CustomTextField
                      label="Designation"
                      id="designation"
                      name="designation"
                      onChange={handleOnchange}
                      value={assessmentsdata?.designation || ""}
                      disabled={true}
                    />
                  </Grid>
                </>
                {/* )} */}
            
              <Grid item xs={12} md={4} sm={6} >
                <CustomTextFieldWithSearch
                  label={"Task Code"}
                  id={"taskCode"}
                  name={"taskCode"}
                  onChange={handleOnchange}
                  value={assessmentsdata?.taskCode || ""}
                  options={option?.taskCode || []}
                  error={error?.taskCode}
                  errorMessage={errorMessage?.taskCode}
                  isMandatoryField={true}
                  disabled={true}
                  hideSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Task Description"
                  id="taskdescription"
                  name="taskDescription"
                  onChange={handleOnchange}
                  value={assessmentsdata?.taskDescription || ""}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <FormControl component="fieldset" error={error.repairType}>
                  <Typography variant="labelSm" color={"text.primary"} component={"label"}>
                    Repair Type
                    <Typography component={"span"} color={"error"}>
                      *
                    </Typography>
                  </Typography>
                  <RadioGroup
                    row
                    name="repairType"
                    onChange={handleRepairTypeChange}
                    value={assessmentsdata?.repairType || ""}
                    aria-required={true}
                    defaultValue="Inhouse"
                  >
                    <FormControlLabel value="Inhouse" control={<Radio />} label="Inhouse" disabled={viewmode || mappedStatus === 6} />
                    {/* <FormControlLabel value="Inhouse" control={<Radio />} label="Inhouse" disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || scheduled} /> */}
                    <FormControlLabel value="Outsource" control={<Radio />} label="Outsource"  disabled={viewmode || mappedStatus === 6} />
                    {/* <FormControlLabel value="Outsource" control={<Radio />} label="Outsource" disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || scheduled} /> */}
                  </RadioGroup>
                  <FormHelperText>{errorMessage.repairType}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  label={"Parts Required"}
                  name="partsRequired"
                  value={assessmentsdata?.partsRequired || ""}
                  onChange={handleOnchange}
                  options={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                  disabled={viewmode || mappedStatus === 6}
                // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}

                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  label={"Asset Taken Location"}
                  name="assetTakenLocation"
                  value={assessmentsdata?.assetTakenLocation || ""}
                  onChange={handleOnchange}
                  options={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                  disabled={viewmode || mappedStatus === 6}
                // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomTextArea
                  label={scheduled ? "Assignee Finding" : "Respond Finding"}
                  id="respondedFinding"
                  onChange={(e) => handleOnchange(e, "respondedFinding")}
                  value={assessmentsdata?.respondedFinding || ""}
                  disabled={viewmode || mappedStatus === 6}
                  // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                  maxLength={100}
                />
              </Grid>
            </Grid>
          </Box>

          {(setOutsourceDetails || !!(assessmentsdata?.repairType === "Outsource")) && (
            <>
              <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                <Typography variant='title2' >Outsource Details</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} sm={6}>
                    <CustomTextFieldWithSearch
                      label={"Vendor"}
                      id={"vendor"}
                      name={"vendor"}
                      onChange={handleOnchange}
                      value={assessmentsdata?.vendor || ""}
                      options={option?.vendor || []}
                      disabled={viewmode || mappedStatus === 6}
                      isMandatoryField={setOutsourceDetails ? true : false}
                      error={error?.vendor}
                      errorMessage={errorMessage?.vendor || ""}
                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sm={6}>
                    <CustomTextField
                      label="Outsource Respond remarks"
                      name="outsourceRespondRemarks"
                      value={assessmentsdata?.outsourceRespondRemarks || ""}
                      onChange={handleOnchange}
                      disabled={viewmode || mappedStatus === 6}
                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          )}

          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant='title2'> Repair Tracker </Typography>
              <Box sx={{ flexGrow: 1 }} />
              {!viewmode && mappedStatus !== 6 && (
                // {!viewmode && mappedStatus !== 4 && mappedStatus !== 5 && mappedStatus !== 6 && || mappedStatus !== 8 (
                <AddRowButton onClick={handleOpenDialog} />
              )}
            </Stack>
            {error?.repairTrackerRows && (
              <Typography component={"span"} color={"error"}>
                {errorMessage?.repairTrackerRows}*
              </Typography>
            )}
            <CustomAgGrid
              refSet={gridAPI}
              rows={rows}
              columns={columns_Field}
              setGridApi={setGridApi}
              handleDelete={shouldEnableDeleteAndEdit ? (row) => handleDelete(row) : null}
              handleEdit={shouldEnableDeleteAndEdit ? (row) => handleEdit(row) : null}
            />

          </Box>

          <Box>
            <RoutineInspectionBottomButtons page={page} buttonAttributes={buttonAttributes} outsourseSubmitBtn={setOutsourceDetails} enableAuthorizeButton={false} outsourceHandleConfirm={handledialogforOutSource} disableSubmitBtn={setOutsourceDetails && mappedStatus === 4 || setOutsourceDetails && mappedStatus === 5 || setOutsourceDetails && mappedStatus === 6 ? true : false} />
          </Box>
        </form>
      </Box>

      <AddRowDialogue
        open={dialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirm}
        editMode={editData}
        rows={rows}
        setRows={setRows}
        vendorName={assessmentsdata?.vendor?.label || ""}
      />
      <CustomAlert
        open={outSourceDialog}
        onClose={handleCloseDialog}
        onConfirm={handleOutsourceSubmit}
        content={`${basicDetails?.workOrderNo || ""} have been successfully shared to Vendor`}
        confirmBtn='OK'
      />

      <CustomAlert
        open={errorDialog}
        onClose={handleCloseErrRequestDialog}
        onConfirm={handleConfirmErrRequestDialog}
        content={errorDialogMssg}
        confirmBtn='OK'
      />

      <CustomDialog
        open={deleteDialog}
        onClose={handleCloseCancelDialog}
        onConfirm={handleConfirmDelete}
        content="Are you sure you want to Delete?"
        cancelBtn="No"
        confirmBtn="Yes"
      />

    </>
  );
};

export default RoutineInspectionAssessments
